
  import {defineComponent} from 'vue'
  import headerText from '../header/headerText.js'
  import useStore from "@/store";
  import {useRoute} from "vue-router";

  export default defineComponent({
    name: 'index',
    setup() {
      const route = useRoute()
      const store = useStore()
      return {
        headerText,
        store,
        route
      }
    }

  })
